export const PROFIT_LOSS_ID = 'id-profit-and-loss';

export const BALANCE_SHEET_ID = 'id-balance-sheet';

export const NON_FINANCIAL_DRIVERS_ID = 'id-non-financial-drivers';

export const NOT_CLICKABLE_IDS = [PROFIT_LOSS_ID, BALANCE_SHEET_ID, NON_FINANCIAL_DRIVERS_ID];
